import React from 'react'

import { Gallery, Title } from '@cms/ui'
import Head from '../../head'

const Page = (props) => {
  if (!props.data) return null
  if (!props.data.length) return null

  const desc = `Chan Kwan-Lok's publications`
  const { zh_name, en_name, thumbnail } = props.data[0]

  return (
    <>
      <Head
        title={`${en_name} | ${zh_name}`}
        desc={desc}
        img={`${process.env.NEXT_IMAGE_ENDPOINT}/${thumbnail.hash}`}
        ogTitle={`${en_name} | ${zh_name}`}
      />
      <Title>{`Publications`}</Title>
      <Gallery items={props.data} />
    </>
  )
}

export default Page

export async function getStaticProps() {
  const _data = await fetch(
    `${process.env.NEXT_SERVER_STRAPI_ENDPOINT}/api/publications?populate=*`
  ).then((res) => res.json())

  const { parseData } = await import('../../data')

  return {
    props: {
      data: parseData(_data, 'publications').map(({ thumbnail, id, link, en_name, zh_name }) => ({
        thumbnail,
        id,
        link,
        zh_name,
        en_name,
      })),
    },
  }
}
